export enum BusinessProfileRoutes {
  root = 'business-profile',
  companyLocation = 'company-location',
  generalInfo = 'general-info',
  businessInfo = 'business-info',
  peopleToContact = 'people-to-contact',
  termsAndPrivacy = 'terms-and-privacy',
}
